import * as React from 'react';
import { ids } from 'app/area/administration/constants';

export interface SearchTitleProps {
  title: string;
}

export const SearchTitle = ({ title }: SearchTitleProps) => (
  <div id={ids.list_search} className="row">
    <div className="col-12">
      <h1>{title}</h1>
    </div>
  </div>
);
